import { Shimmer, ShimmerElementType } from "@fluentui/react";
import React from "react";
import { useComponentLogger } from "../../../shared/logging";
import { ShimmerLineProps } from "../Shimmer.types";

// Note: This component is mocked in all monorepo tests, except for ShimmerLine.spec.tsx
// https://microsoft.visualstudio.com/Universal%20Store/_wiki/wikis/Universal%20Store_wiki/66704/Mocking-components
export const ShimmerLine: React.FC<ShimmerLineProps> = ({
    height,
    width = "100%",
    shimmerColors
}) => {
    useComponentLogger("ShimmerLine");

    return (
        <Shimmer
            width={width}
            shimmerElements={[
                { type: ShimmerElementType.line, width: "100%", height }
            ]}
            shimmerColors={shimmerColors}
        />
    );
};
